<template>
    <section>
      <div>
        <div class="grid grid-cols-12 bg-lifeboost-red-lighter gap-x-8">
          <div class="items-center lg:col-span-7 col-span-12 px-4 bg xl:ml-[calc((100vw_-_1024px)_/_2)] grid xl:pl-0 xl:pr-0">
            <div class="py-8 md:py-8 lg:py-0 lg:pr-10">
              <h3 class="mb-2 text-2xl font-bold text-center md:text-3xl lg:text-3xl xl:text-40 xl:leading-10 font-ww-bold md:text-left" v-html="heading"></h3>
              <div class="font-bold text-lg md:text-xl lg:text-2xl xl:text-2xl  font-ww-medium !leadgin-5 md:text-left text-center" v-html="subheading"></div>
  
              <div class="grid grid-cols-1 mt-8 sm:grid-cols-2 gap-y-10 lg:gap-x-8 md:gap-x-4 gap-x-8">
                <div class="grid items-start grid-cols-12 gap-x-2" v-for="(item, index) in items" :key="index">
                  <div class="col-span-2 sm:col-span-3 md:col-span-3">
                    <nuxt-img
                      :src="item.src"
                      :alt="item.alt"
                      class="object-cover"
                      format="webp"
                      loading="lazy"
                      width="52"
                      height="52"
                    />
                  </div>
                  <div
                    class="col-span-9 lg:pl-4 textp lg:col-span-9 md:col-span-8 xl:pl-0 font-ww-light !leading-5 items-center flex"
                    v-html="item.description"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid items-center col-span-12 lg:my-16 lg:col-span-5">
            <nuxt-img
              :src="mainImage.src"
              :alt="mainImage.alt"
              class="object-cover mx-auto mix-blend-multiply"
              format="webp"
              loading="lazy"
              sizes="xs:330px sm:440px md:745vw lg:388px xl:494"
              width="619"
              height="619"
            />
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  
  const props = defineProps({
    heading: {
      type: String,
      default: "Get The Best Single Origin Coffee Beans In our top selling flavors!",
    },
    subheading: {
      type: String,
      default: "Act Now As We Have A VERY Limited Supply",
    },
    items: {
      type: Array,
      default: () => [
        {
          src: "/assets/images/Group-icon-1.png",
          alt: "section image",
          description: "Organic Medium Roast Coffee Beans (Specialty Arabica Beans)",
        },
        {
          src: "/assets/images/Group-icon-2.png",
          alt: "section image",
          description: "Single Origin From Small Farms In A Nationally Protected Area",
        },
        {
          src: "/assets/images/Group-icon-3.png",
          alt: "section image",
          description:
            "Shade And Elevation Grown (Slow Grown In The Mountains Of Nicaragua For Optimal Flavor And Low Acidity)",
        },
        {
          src: "/assets/images/Group-icon-4.png",
          alt: "section image",
          description: "Fairly Traded (Our Coffee Farmers Are Paid A Fair Wage)",
        },
      ],
    },
    mainImage: {
      type: Object,
      default: () => ({
        src: "/assets/images/coffee-1234.png",
        alt: "section image",
      }),
    },
  });
  
  defineBuilderComponent({
    friendlyName: "FeatureInfoIconsImage",
    inputs: [
      {
        name: "heading",
        type: "richText",
        friendlyName: "Main Heading",
        defaultValue: "Get The Best Single Origin Coffee Beans In our top selling flavors!",
      },
      {
        name: "subheading",
        type: "richText",
        friendlyName: "Subheading",
        defaultValue: "Act Now As We Have A VERY Limited Supply",
      },
      {
        name: "items",
        type: "list",
        friendlyName: "Feature Items",
        subFields: [
          {
            name: "src",
            type: "file",
            friendlyName: "Icon Image Source",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "/assets/images/Group-icon-1.png",
          },
          {
            name: "alt",
            type: "string",
            friendlyName: "Icon Alt Text",
            defaultValue: "section image",
          },
          {
            name: "description",
            type: "richText",
            friendlyName: "Description",
            defaultValue: "Organic Medium Roast Coffee Beans (Specialty Arabica Beans)",
          },
        ],
        defaultValue: [
          {
            src: "/assets/images/Group-icon-1.png",
            alt: "section image",
            description: "Organic Medium Roast Coffee Beans (Specialty Arabica Beans)",
          },
          {
            src: "/assets/images/Group-icon-2.png",
            alt: "section image",
            description: "Single Origin From Small Farms In A Nationally Protected Area",
          },
          {
            src: "/assets/images/Group-icon-3.png",
            alt: "section image",
            description:
              "Shade And Elevation Grown (Slow Grown In The Mountains Of Nicaragua For Optimal Flavor And Low Acidity)",
          },
          {
            src: "/assets/images/Group-icon-4.png",
            alt: "section image",
            description: "Fairly Traded (Our Coffee Farmers Are Paid A Fair Wage)",
          },
        ],
      },
      {
        name: "mainImage",
        type: "object",
        friendlyName: "Main Image",
        subFields: [
          {
            name: "src",
            type: "file",
            friendlyName: "Image Source",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "/assets/images/coffee-1234.png",
          },
          {
            name: "alt",
            type: "string",
            friendlyName: "Image Alt Text",
            defaultValue: "section image",
          },
        ],
      },
    ],
  });
  </script>
  